import React from 'react';
import { Button } from '../../../components/ui/Button';
import { useProfileForm } from '../hooks/useProfileForm';
import { ProfileSummaryCard } from './partials/ProfileSummaryCard';
import { QuickActionsCard } from './partials/QuickActionsCard';
import { PersonalInfoCard } from './partials/PersonalInfoCard';
import { CompanyInfoCard } from './partials/CompanyInfoCard';
import { AddressCard } from './partials/AddressCard';
import { PushNotificationsCard } from './PushNotificationsCard';

const MyDataTab: React.FC = () => {
    const { formData, user, subscription, isSaving, isDirty, handleChange, handleSave, handleCancel } =
        useProfileForm();

    if (!formData) {
        return (
            <p className="py-s8 text-center text-sm text-muted" role="status">
                Carregando perfil...
            </p>
        );
    }

    return (
        <div className="grid grid-cols-1 gap-s4 lg:grid-cols-12">
            <aside className="space-y-s4 lg:col-span-4">
                <ProfileSummaryCard
                    formData={formData}
                    user={user}
                    planName={subscription?.planName || 'Free'}
                />
                <QuickActionsCard />
            </aside>

            <div className="space-y-s4 lg:col-span-8">
                <PersonalInfoCard formData={formData} onChange={handleChange} />
                <CompanyInfoCard formData={formData} onChange={handleChange} />
                <AddressCard formData={formData} onChange={handleChange} />
                <PushNotificationsCard />

                <div className="flex flex-col-reverse gap-s2 pt-s2 sm:flex-row sm:items-center sm:justify-end sm:gap-s3">
                    <Button
                        type="button"
                        variant="ghost"
                        onClick={handleCancel}
                        disabled={!isDirty || isSaving}
                        className="min-h-11 w-full touch-manipulation text-secondary hover:text-default sm:min-h-0 sm:w-auto"
                    >
                        Cancelar
                    </Button>
                    <Button
                        type="button"
                        onClick={handleSave}
                        disabled={!isDirty || isSaving}
                        className="min-h-11 w-full touch-manipulation sm:min-h-0 sm:w-auto sm:px-8"
                    >
                        {isSaving ? 'Salvando...' : 'Salvar Alterações'}
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default MyDataTab;
